module.exports = __webpack_public_path__ + "img/748.9203c7fb.jpg";